import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import './AutoplayVideoOverlay.css';


function AutoplayVideoOverlay(props) {
  const [open, setOpen] = useState(true);

  const onClick = () => {
    setOpen(false);
    props.onCtaClick();
  };

  return (
    <Dialog
      aria-describedby="Naked News campaign video"
      aria-labelledby="Naked News membership campaign"
      className="autoplayVideoVerlay__modal"
      maxWidth="md"
      open={open}
      scroll="body"
      onClose={() => setOpen(false)}
    >
      <div className="autoplayVideoVerlay__content">
        <h2 className="autoplayVideoVerlay__title">
          {props.title}
        </h2>
        <div className="autoplayVideoVerlay__content-close">
          <button className="autoplayVideoVerlay__close-cta" onClick={() => setOpen(false)}>
            <CloseIcon />
          </button>
        </div>

        <div className="autoplayVideoVerlay__video-container">
          <video autoPlay={true} className="autoplayVideoVerlay__video" controls={true} muted={true} playsInline={true}>
            <source
              src={props.videoUrl}
              type="video/mp4"
            />
          </video>
        </div>
        <div className="autoplayVideoVerlay__cta-container">
          <button className="autoplayVideoVerlay__cta" onClick={onClick}>
            {props.ctaText}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

AutoplayVideoOverlay.propTypes = {
  ctaText: PropTypes.string,
  title: PropTypes.string,
  videoUrl: PropTypes.string,
};

AutoplayVideoOverlay.defaultProps = { ctaText: 'Get Your Membership' };

export default AutoplayVideoOverlay;
